import cv from "./DietherMarkFiel_Resume.pdf"

export default cv;